
const Server = require('server/js/lib/server.js');
const hosts = {
	any: require('./any'),
	my: require('./my'),
};


module.exports = function () {
	return new Server({
		hosts: hosts,
	});
};

